<div
  id="parentGridLiveView"
  style="
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  ">
  <ng-template #spring>
    <mat-toolbar color="primary">
      <!-- <button color="accent" mat-icon-button (click)="showIcons = !showIcons">
    <mat-icon matTooltip="Show Options" *ngIf="!showIcons">arrow_forward_ios</mat-icon>
    <mat-icon matTooltip="Hide Options" style="left: 4px;" *ngIf="showIcons">arrow_back_ios</mat-icon>
  </button> -->
      <div>
        <ng-container *ngFor="let option of options; let i = index">
          <button
            mat-mini-fab
            matTooltip="{{
              appGrid.selectedGridElements.length > 0 ? 'Selected' : 'All'
            }} {{ option.Title }}"
            mat-icon-button
            (click)="videogridfunctionCallback(option.Callback)">
            <mat-icon>{{ option.Icon }}</mat-icon>
          </button>
        </ng-container>

        <button
          mat-mini-fab
          matTooltip="Clear {{
            appGrid.selectedGridElements.length > 0 ? 'selected' : 'all'
          }} Grid"
          mat-icon-button
          (click)="clearGrid()">
          <mat-icon>remove_from_queue</mat-icon>
        </button>
        <button
          mat-mini-fab
          matTooltip="Change {{
            appGrid.selectedGridElements.length > 0 ? 'selected' : 'all'
          }} View"
          mat-icon-button
          [matMenuTriggerFor]="menu">
          <mat-icon>view_quilt</mat-icon>
        </button>
        <button
          mat-mini-fab
          matTooltip="Fullscreen"
          mat-icon-button
          (click)="toggleFullScreen()">
          <mat-icon>fullscreen</mat-icon>
        </button>
        <button
          mat-mini-fab
          matTooltip="Change {{
            appGrid.selectedGridElements.length > 0 ? 'selected' : 'all'
          }} Videos Content Fit"
          mat-icon-button
          [matMenuTriggerFor]="VideoFit">
          <mat-icon>aspect_ratio</mat-icon>
        </button>
        <button
          mat-mini-fab
          matTooltip="Click{{
            appGrid.selectedGridElements.length > 0 ? ' selected' : ' all'
          }} Grids Snap Shots"
          mat-icon-button
          (click)="clickSnapshot()">
          <mat-icon>camera_enhance</mat-icon>
        </button>
        <mat-menu class="video-grid-video-menu" #VideoFit="matMenu">
          <!-- for videoFit loop on items like { name: "Fill", value: "fill" },-->
          <ng-template matMenuContent let-id="id">
            <button
              mat-menu-item
              (click)="changeAllVideoFit(fit.value)"
              *ngFor="let fit of videoFit">
              <span *ngIf="currentVideoFit == fit.value" style="color: green">{{
                fit.name
              }}</span
              ><span *ngIf="currentVideoFit != fit.value">{{ fit.name }}</span>
            </button>
          </ng-template>
        </mat-menu>
        <button
          mat-mini-fab
          matTooltip="Toggle Stich Videos (Show/Hide Details & Boundary)"
          mat-icon-button
          (click)="stichVideos()">
          <mat-icon>settings_overscan</mat-icon>
        </button>
      </div>

      <span class="example-spacer"></span>

      <div id="view_list" [hidden]="true">
        <div
          (click)="showViewList = !showViewList"
          style="
            width: 200px;
            height: 25px;
            display: inline-block;
            border: 1px solid white;
            color: white;
            text-align: center;
            cursor: pointer;
            background-color: #23272a;
            color: lightgrey;
          ">
          <mat-icon style="float: left">view_quilt</mat-icon>
          {{ SelectedView.heading }} ({{ SelectedView.Text }})
          <mat-icon style="float: right">keyboard_arrow_down</mat-icon>
        </div>
        <div
          [hidden]="!showViewList"
          style="
            position: absolute;
            z-index: 500;
            height: 400px;
            overflow: auto;
            width: 200px;
            background-color: #23272a;
          ">
          <div
            (click)="viewSelected(index)"
            *ngFor="let view of _ViewList; let index = index"
            class="viewOptionsList">
            <img
              style="height: 70px; width: 80px"
              [src]="'/assets/layout_icons/' + view.Text + '.png'" />
            <span> {{ view.Text }}</span>
          </div>
        </div>
      </div>
      <div id="view_select" [hidden]="true">
        <mat-icon>view_quilt</mat-icon>
        {{ SelectedView.heading }}
        <mat-form-field>
          <mat-select
            [(ngModel)]="SelectedView"
            (ngModelChange)="view_selected($event)">
            <mat-option
              style="margin-top: 10px"
              *ngFor="let view of _ViewList; let index = index"
              [value]="view">
              <img
                style="height: 50px; width: 50px"
                [src]="'/assets/layout_icons/' + view.Text + '.png'" />
              <span> {{ view.Text }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- mat menu -->
      <div id="view_menu" [hidden]="false">
        {{ SelectedView.heading }} ({{ SelectedView.Text }})

        <mat-menu class="video-grid-video-menu" #menu="matMenu">
          <!-- loop ViewList -->
          <button
            mat-menu-item
            *ngFor="let view of _ViewList; let index = index"
            (click)="viewSelected(index)">
            <img
              style="height: 70px; width: 70px"
              [src]="'/assets/layout_icons/' + view.Text + '.png'" />
            <span> {{ view.Text }}</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
  </ng-template>
  <div id="parentGrid" style="height: 100%">
    <lib-app-grid
      id="appGrid"
      #appGrid
      [idx]="'Grid'"
      [GridConfig]="SelectedView"
      [parentHeight]="selfheight"
      [parentWidth]="selfwidth"
      [Rows]="Rows"
      [Cols]="Cols"
      [gridMode]="gridMode"
      [playDuplicate]="playDuplicate"
      [playerServerIp]="playerServerIp"
      [streamerIp]="streamerIp"
      [hideTime]="false"
      [cameras]="cameras"
      [header]="false"
      [options]="options"
      [DataSubject]="gridSubject"
      [eventDataSubject]="eventDataSubject"
      (videoStartEmitterFromGrid)="VideoGridVideoStarted($event)"
      (clearGrid)="onClearGrid()"
      (onFunctionClick)="videogridfunctionCallback($event)"
      (onCloseElement)="onElementRemovedFromGrid($event)">
      (dimensionChange)="onDimensionChange($event)"</lib-app-grid>
  </div>
  <mat-toolbar color="accent" style="height: 23px; justify-content: center; height: 24px; justify-content: center; border-radius: 5px;">
  <div id="springBtn" style="height: 24px">
    <mat-icon
      matTooltip="Show Options"
      id="springIcon"
      color="primary"
      (click)="openBottomSheet()"
      >drag_handle
    </mat-icon>
  </div>
</mat-toolbar>
</div>
